import React from 'react';

// ///////////////// LAZY LOAD ////////////////////////////
import Loadable from 'react-loadable';
import Loading from './common_components/Loading';

const AsyncMain = Loadable({
  loader: () => import('./update_container_components/Main'),
  loading: Loading
});
// ////////////////////////////////////////////////////////

export default class UpdateContainer extends React.Component {
  render() {
    return <AsyncMain {...this.props} />;
  }
}
